var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_345_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29244 9.46202L5.41244 5.58202L9.29244 1.70202C9.38503 1.60944 9.45847 1.49953 9.50857 1.37856C9.55868 1.2576 9.58447 1.12795 9.58447 0.997021C9.58447 0.86609 9.55868 0.736442 9.50857 0.615478C9.45847 0.494513 9.38503 0.384603 9.29244 0.292021C9.19986 0.199439 9.08995 0.125999 8.96899 0.0758939C8.84802 0.0257889 8.71837 -9.75508e-10 8.58744 0C8.45651 9.7551e-10 8.32687 0.0257889 8.2059 0.0758939C8.08494 0.125999 7.97503 0.199439 7.88244 0.292021L3.29244 4.88202C3.19974 4.97453 3.12619 5.08442 3.07601 5.2054C3.02583 5.32637 3 5.45605 3 5.58702C3 5.71799 3.02583 5.84767 3.07601 5.96865C3.12619 6.08962 3.19974 6.19951 3.29244 6.29202L7.88244 10.882C8.27244 11.272 8.90244 11.272 9.29244 10.882C9.67244 10.492 9.68244 9.85202 9.29244 9.46202Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5845,
    height: 11.1745,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.429114088e4a8f32fc920af4fe975fdc.svg";
export { ForwardRef as ReactComponent };